<template>
  <kst-page-print-list pageFooter
    v-slot="{ title }"
    :catalog="SearchCatalog"
    :params="searchParams"
    :search="searchData"
    @init="handleInit"
  >
    <div class="columns is-mobile">
      <div class="column is-half">
        <Company :data="companyData"/>
      </div>
      <div class="column is-half">
        <div class="is-size-3">{{ title }}</div>
      </div>
    </div>

    <List class="mt-4" :items="items"/>
  </kst-page-print-list>
</template>

<script>
import Model from "../DbpyModel.js";
import SearchCatalog from "../List/SearchCatalog.js";
import Services from "../../../services/Api/DebtPayServices.js";

import List from "./DbpyPL_List.vue";
import Company from "../../Company/RelatedPrintDetails/CpRPD.vue";

export default {
  components: {
    List,
    Company
  },
  data: () => ({
    SearchCatalog: SearchCatalog,
    companyData: {},
    items: [],
    searchData: {
      Search: "",
      Date: null,
      PaymentTypeName: null,
      StatusID: null,
      VendorID: null,
      VendorName: "",
      WarehouseID: null
    },
    searchParams: ["Search", "Date", "PaymentTypeName", "StatusID", "VendorID",
      "VendorName", "WarehouseID"]
  }),
  created() {
    this.resetSearch();
  },
  methods: {
    /*** by page ***/

    handleInit(loadPrint) {
      this.resetData();

      const options = this.getListOptions();
      const config = Services.getPrintListData(options);
      loadPrint(config, this.handleInit_Success);
    },
    handleInit_Success(data) {
      this.companyData = data.CompanyDetails;
      this.items = data.List;

      for (const row of this.items) {
        Model.setDetailsByStatus(row);
      }
    },

    /*** custom ***/

    resetData() {
      this.companyData = {};
      this.items = [];
    },
    resetSearch() {
      this.searchData.Search = "";
      this.searchData.Date = this.$kst.In.getDefaultDateRange();
      this.searchData.PaymentTypeName = this.$kst.Search.OptionAll;
      this.searchData.StatusID = this.$kst.Search.OptionAll;
      this.searchData.VendorID = null;
      this.searchData.VendorName = "";
      this.searchData.WarehouseID = this.$kst.Session.getDefaultWarehouseID();
    },
    getListOptions() {
      const paymentType =
        this.$kst.Search.getValue(this.searchData.PaymentTypeName, null) === null
        ? null
        : this.searchData.PaymentTypeName;
      const vendorId = this.$kst.Out.getInteger(this.searchData.VendorID);
      const vendorName = vendorId === null
        ? this.$kst.Out.getString(this.searchData.VendorName) : null;

      return {
        startdate: this.$kst.Out.getDateString(this.searchData.Date[0]),
        enddate: this.$kst.Out.getDateString(this.searchData.Date[1]),
        paymenttype: paymentType,
        status: this.$kst.Search.getValue(this.searchData.StatusID),
        vendor: vendorId,
        vendorname: vendorName,
        warehouse: this.$kst.Search.getValue(this.searchData.WarehouseID),
        search: this.$kst.Out.getString(this.searchData.Search),
        field: Model.List.Search.Fields
      };
    }
  }
}
</script>